module.exports = __webpack_public_path__ + "images/background/theme_thumbnail/2-off-dcd4bb382ca0a8d4678a5eab448f3d99.png";